import { useNavigate } from "@tanstack/react-router";

import { BreadcrumbContainer, SimpleBreadcrumb } from "components/ui/breadcrumb/SimpleBreadcrumb";
import { BidReport } from "lib/hooks/api/bid/bid_reports/useBidReport";
import { BidDetails } from "lib/hooks/api/bid/bids/useBid";
import { useCurrentUser } from "lib/hooks/api/users/useCurrentUser";
import { routes } from "lib/routes";
import { QualificationReportHeaderActionButtons } from "./QualificationReportHeaderActionButtons";

type Props = {
  bidId: string;
  bidName?: string;
  bidReportId: string;
  noticeGuid?: string;
  notice?: BidReport["notice"];
  urlShareSignature?: string;
  hasEditAccess: boolean;
  winThemes: BidDetails["winThemes"];
  onRegenerateBidReport: () => void;
};

export function QualificationReportHeader({
  bidId,
  bidName,
  bidReportId,
  noticeGuid,
  notice,
  urlShareSignature,
  hasEditAccess,
  winThemes,
  onRegenerateBidReport,
}: Props) {
  const navigate = useNavigate();
  const { data: currentUser } = useCurrentUser();
  // We can remove this check if we don't want to share this report at all
  const loggedInUser = !!currentUser;

  return (
    <BreadcrumbContainer>
      <SimpleBreadcrumb
        items={
          bidId
            ? [
                {
                  label: "Bids",
                  path: loggedInUser ? routes.bids : undefined,
                },
                {
                  label: bidName || "Linked bid",
                  path: loggedInUser ? `${routes.bids}/${bidId}` : undefined,
                },
                {
                  label: "Qualification report",
                },
              ]
            : [
                {
                  label: "Qualification report",
                },
              ]
        }
        onNavigate={(path: string) => {
          if (loggedInUser) {
            void navigate({ to: path });
          } else {
            void navigate({ to: "/auth/login" });
          }
        }}
      />
      <QualificationReportHeaderActionButtons
        bidReportId={bidReportId}
        bidId={bidId}
        bidName={bidName}
        noticeGuid={noticeGuid}
        notice={notice}
        urlShareSignature={urlShareSignature}
        hasEditAccess={hasEditAccess}
        winThemes={winThemes}
        onRegenerateBidReport={onRegenerateBidReport}
      />
    </BreadcrumbContainer>
  );
}
